// extracted by mini-css-extract-plugin
export default {"price-container":"PriceColumn__price-container__UarLF"};